var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"21","height":"20","viewBox":"0 0 21 20","fill":"none"}},[_c('path',{attrs:{"d":"M5.6001 7.5L10.6001 12.5L15.6001 7.5","stroke":"currentColor","stroke-width":"1.66667","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }